import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import Header from '../header';
import Footer from '../footer';
import Steper from './components/steper';
import CustomInput from '../../components/customInput';
import Calendar from './components/calendar';
import TimesSelect from './components/timesSelect';
import CustomButton from '../../components/customButton';
import CustomSelect from '../../components/customSelect';
import { langSelector } from '../../store/langSlice';
import getEnvironement, { getLang } from '../../environnement';
import { configSelector, setConfig } from '../../store/configSlice';
import CustomMultipleSelect from '../../components/customMultipleSelect';
import CustomBackdrop from '../../components/backdrop';
import { userSelector } from '../../store/userSlice';
import { toast, ToastContainer } from 'react-toastify';

export default function DemandeSalle({
  activeItem
}) {
  const [cin, setCin] = useState('');
  const [departement, setDepartement] = useState('');
  const [nomPrenomFormateur, setNomPrenomFormateur] = useState('');
  const [nomPrenomAssistantFormateur, setNomPrenomAssistantFormateur] = useState('');
  const [programmeFormation, setProgrammeFormation] = useState('');
  const [materiel, setMateriel] = useState('');
  const [consommables, setConsommables] = useState('');
  const [nombreParticipant, setNombreParticipant] = useState('');
  const [typeApprentis, setTypeApprentis] = useState('');
  const [reservationYear, setReservationYear] = useState('');
  const [reservationMonth, setReservationMonth] = useState('');
  const [reservationDay, setReservationDay] = useState('');
  const [selectedTimes, setSelectedTimes] = useState([]);

  const [cinError, setCinError] = useState('');
  const [departementError, setDepartementError] = useState('');
  const [nomPrenomFormateurError, setNomPrenomFormateurError] = useState('');
  const [nomPrenomAssistantFormateurError, setNomPrenomAssistantFormateurError] = useState('');
  const [programmeFormationError, setProgrammeFormationError] = useState('');
  const [materielError, setMaterielError] = useState('');
  const [consommablesError, setConsommablesError] = useState('');
  const [nombreParticipantError, setNombreParticipantError] = useState('');
  const [typeApprentisError, setTypeApprentisError] = useState('');
  const [reservationYearError, setReservationYearError] = useState('');
  const [reservationMonthError, setReservationMonthError] = useState('');
  const [reservationDayError, setReservationDayError] = useState('');
  const [selectedTimesError, setSelectedTimesError] = useState('');

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const lang = useSelector(langSelector);
  const config = useSelector(configSelector);
  const user = useSelector(userSelector);
  const navigate = useNavigate();

  function getListFromData(data, frKey, enKey, isValue=false) {
    let list = [];
    for (let i = 0; i < data.length; i++) {
      if (lang === 'fr' || isValue) {
        list.push(data[i][frKey]);
      } else {
        list.push(data[i][enKey]);
      }
    }
    return list;
  }

  function getMonthName(monthNumber) {
    const monthNames = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];

    return monthNames[monthNumber];
  }

  function getTypeApprentis(id) {
    const typeApprentis = ['externes', 'médecins résidents', 'médecins internes'];

    return typeApprentis[id];
  }

  function getRange(n) {
    const result = [];
    for (let i = 1; i <= n; i++) {
      result.push(i);
    }
    return result;
  }

  function getPastDays(year, month) {
    const today = new Date();

    if (today.getFullYear() > year) {
      return getRange(new Date(year, month, 0).getDate());
    
    } else if (today.getFullYear() === parseInt(year) && today.getMonth() + 1 > month) {
      return getRange(new Date(year, month, 0).getDate());
    
    } else if (today.getFullYear() === parseInt(year) && today.getMonth() + 1 === month) {
      const currentDay = today.getDate();
      const pastDays = [];
      for (let i = 1; i < currentDay; i++) {
        pastDays.push(i);
      }

      return pastDays;
    
    } else {
      return [];
    }
  }

  function mergeArrays(arr1, arr2) {
    const mergedArray = arr1.concat(arr2);
    return [...new Set(mergedArray)];
  }

  function getMonthNumber(month) {
    const months = {
      'Janvier': 1,
      'Février': 2,
      'Mars': 3,
      'Avril': 4,
      'Mai': 5,
      'Juin': 6,
      'Juillet': 7,
      'Août': 8,
      'Septembre': 9,
      'Octobre': 10,
      'Novembre': 11,
      'Décembre': 12,
    };
  
    return months[month];
  }

  function getDatesInMonth(month, year, dates) {
    const monthNumber = getMonthNumber(month);
  
    const resultDays = dates
      .map((date) => {
        const currentDate = new Date(date);
        if (currentDate.getFullYear() === parseInt(year) && currentDate.getMonth() + 1 === monthNumber) {
          return currentDate.getDate();
        }
        return null;
      })
      .filter(index => index !== null);
      
    const pastDays = getPastDays(year, monthNumber);
    
    const result = mergeArrays(pastDays, resultDays);

    return result;
  }

  function getPeriodesByDate(data, year, month, day) {
    const newMonth = `${month}`.length === 1 ? `0${month}` : `${month}`;
    const newDay = `${day}`.length === 1 ? `0${day}` : `${day}`;
    const date = `${year}-${newMonth}-${newDay}`;
    
    return data.find((item) => item.date === date) ? data.find((item) => item.date === date).periodes : [];
  }

  const dispatch = useDispatch();

  const setConfigData = useCallback(async () => {
    const url = `${getEnvironement().API_URL}/config`;
    await axios.post(url)
      .then((res) => dispatch(setConfig(res.data)))
  }, [dispatch]);

  useEffect(() => {
    setConfigData();
  }, [setConfigData]);

  function addReservation() {
    const url = `${getEnvironement().API_URL}/reservations`;
    const data = {
      cin,
      lang,
      departement,
      nomPrenomFormateur,
      nomPrenomAssistantFormateur,
      programmeFormation,
      materiel,
      consommables,
      nombreParticipant,
      typeApprentis,
      reservationYear,
      reservationMonth: getMonthNumber(reservationMonth),
      reservationDay,
      periodesReservation: selectedTimes.length === 0 ? null : JSON.stringify(selectedTimes),
    };
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    setOpenBackdrop(true);
    axios.post(url, data, config)
      .then((res) => {
        setTimeout(() => {
          setOpenBackdrop(false);
        }, 1000)
        return res;
      })
      .then((res) => {
        if (user) {
          navigate('/reservations', {state: {fromDemandeSalle: true}});
        } else {
          navigate('/suivre-demande', {state : {fromDemandeSalle: true, reservation: res.data.reservation}});
        }
      })
      .then(() => {
        setCin('');
        setDepartement('');
        setNomPrenomFormateur('');
        setNomPrenomAssistantFormateur('');
        setProgrammeFormation('');
        setMateriel('');
        setConsommables('');
        setNombreParticipant('');
        setTypeApprentis('');
        setReservationYear('');
        setReservationMonth('');
        setReservationDay('');
        setSelectedTimes('');
        setCinError('');
        setDepartementError('');
        setNomPrenomFormateurError('');
        setNomPrenomAssistantFormateurError('');
        setProgrammeFormationError('');
        setMaterielError('');
        setConsommablesError('');
        setNombreParticipantError('');
        setTypeApprentisError('');
        setReservationYearError('');
        setReservationMonthError('');
        setReservationDayError('');
        setSelectedTimesError('');
      })
      .catch((err) => {
        setOpenBackdrop(false);
        if (err.response.data.errors) {
          err.response.data.errors.cin ? setCinError(err.response.data.errors.cin[0]) : setCinError('');
          err.response.data.errors.departement ? setDepartementError(err.response.data.errors.departement[0]) : setDepartementError('');
          err.response.data.errors.nomPrenomFormateur ? setNomPrenomFormateurError(err.response.data.errors.nomPrenomFormateur[0]) : setNomPrenomFormateurError('');
          err.response.data.errors.nomPrenomAssistantFormateur ? setNomPrenomAssistantFormateurError(err.response.data.errors.nomPrenomAssistantFormateur[0]) : setNomPrenomAssistantFormateurError('');
          err.response.data.errors.programmeFormation ? setProgrammeFormationError(err.response.data.errors.programmeFormation[0]) : setProgrammeFormationError('');
          err.response.data.errors.materiel ? setMaterielError(err.response.data.errors.materiel[0]) : setMaterielError('');
          err.response.data.errors.consommables ? setConsommablesError(err.response.data.errors.consommables[0]) : setConsommablesError('');
          err.response.data.errors.nombreParticipant ? setNombreParticipantError(err.response.data.errors.nombreParticipant[0]) : setNombreParticipantError('');
          err.response.data.errors.typeApprentis ? setTypeApprentisError(err.response.data.errors.typeApprentis[0]) : setTypeApprentisError('');
          err.response.data.errors.reservationYear ? setReservationYearError(err.response.data.errors.reservationYear[0]) : setReservationYearError('');
          err.response.data.errors.reservationMonth ? setReservationMonthError(err.response.data.errors.reservationMonth[0]) : setReservationMonthError('');
          err.response.data.errors.reservationDay ? setReservationDayError(err.response.data.errors.reservationDay[0]) : setReservationDayError('');
          err.response.data.errors.periodesReservation ? setSelectedTimesError(err.response.data.errors.periodesReservation[0]) : setSelectedTimesError('');
          toast.error(getLang(lang).reservationSalle.inputError);
        }
      });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div>
      <ToastContainer />
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Header activeItem={activeItem} />
      <div className='3xl:flex 3xl:justify-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
        <div className='3xl:w-[1200px] mx-10'>
          <Steper step={1}/>
          <CustomInput
            type='text'
            placeholder={getLang(lang).reservationSalle.cin}
            value={cin}
            setValue={setCin}
            isError={cinError !== ''}
            error={cinError}
          />
          <CustomSelect
            placeholder={getLang(lang).reservationSalle.departement}
            value={departement}
            setValue={setDepartement}
            items={getListFromData(config['departement'], 'departement', 'departement_en').map((item, index) => {
              return {id: index, value: config['departement'].find((i) => i['departement'] === item || i['departement_en'] === item).id, label: item}
            })}
            isError={departementError !== ''}
            error={departementError}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).reservationSalle.nomPrenomFormateur}
            value={nomPrenomFormateur}
            setValue={setNomPrenomFormateur}
            isError={nomPrenomFormateurError !== ''}
            error={nomPrenomFormateurError}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).reservationSalle.nomPrenomAssistantFormateur}
            value={nomPrenomAssistantFormateur}
            setValue={setNomPrenomAssistantFormateur}
            isError={nomPrenomAssistantFormateurError !== ''}
            error={nomPrenomAssistantFormateurError}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).reservationSalle.programmeFormation}
            value={programmeFormation}
            setValue={setProgrammeFormation}
            isError={programmeFormationError !== ''}
            error={programmeFormationError}
          />
          <CustomSelect
            placeholder={getLang(lang).reservationSalle.materiel}
            value={materiel}
            setValue={setMateriel}
            items={getListFromData(config['materiel'], 'materiel', 'materiel_en').map((item, index) => {
              return {id: index, value: config['materiel'].find((i) => i['materiel'] === item || i['materiel_en'] === item).id, label: item}
            })}
            isError={materielError !== ''}
            error={materielError}
          />
          <CustomMultipleSelect
            placeholder={getLang(lang).reservationSalle.consommables}
            setValue={setConsommables}
            items={getListFromData(config['consommable'], 'consommable', 'consommable_en').map((item, index) => {
              return {id: index, value: config['consommable'].find((i) => i['consommable'] === item || i['consommable_en'] === item).id, label: item}
            })}
            isError={consommablesError !== ''}
            error={consommablesError}
          />
          <CustomInput
            type='number'
            placeholder={getLang(lang).reservationSalle.nombreParticipant}
            value={nombreParticipant}
            setValue={setNombreParticipant}
            isError={nombreParticipantError !== ''}
            error={nombreParticipantError}
          />
          <CustomSelect
            placeholder={getLang(lang).reservationSalle.typeApprentis}
            value={typeApprentis}
            setValue={setTypeApprentis}
            items={getLang(lang).reservationSalle.typeApprentisItems.map((item, index) => {
              return {id: index, value: getTypeApprentis(index), label: item}
            })}
            isError={typeApprentisError !== ''}
            error={typeApprentisError}
          />
          <div className='mb-10'>
            <p className='font-inter text-primary font-medium text-2xl sm:text-3xl mb-6' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).reservationSalle.choisirDateReservationSalle}</p>
            <div>
              <CustomSelect
                placeholder={getLang(lang).reservationSalle.annee}
                value={reservationYear}
                setValue={setReservationYear}
                items={[
                  {id: 1, value: new Date().getFullYear(), label: new Date().getFullYear()},
                  {id: 2, value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1}
                ]}
                isError={reservationYearError !== ''}
                error={reservationYearError}
              />
              <CustomSelect
                placeholder={getLang(lang).reservationSalle.mois}
                value={reservationMonth}
                setValue={setReservationMonth}
                items={getLang(lang).reservationSalle.moisItems.map((item, index) => {
                  return {id: index, value: getMonthName(index), label: item}
                })}
                isError={reservationMonthError !== ''}
                error={reservationMonthError}
              />
            </div>
            <div className='flex flex-col md:flex-row justify-between gap-10 md:items-center'>
              <Calendar
                numberOfDays={new Date(reservationYear, getMonthNumber(reservationMonth), 0).getDate()}
                disabledList={getDatesInMonth(reservationMonth, reservationYear, config['desactivated_date'].filter((item) => item['all_periodes'] === 1).map((item) => item.date))}
                selectedDay={reservationDay}
                setSelectedDay={setReservationDay}
                isHidden={reservationYear === '' || reservationMonth === ''}
                isError={reservationDayError !== ''}
                error={reservationDayError}
              />
              <div className='flex-grow'>
                <TimesSelect
                  times={[
                    '09:00 - 09:30',
                    '09:30 - 10:00',
                    '10:00 - 10:30',
                    '10:30 - 11:00',
                    '11:00 - 11:30',
                    '11:30 - 12:00',
                    '12:00 - 12:30',
                    '12:30 - 13:00',
                    '13:00 - 13:30',
                    '13:30 - 14:00',
                    '14:00 - 14:30',
                    '14:30 - 15:00',
                  ]}
                  disabledList={getPeriodesByDate(config['desactivated_date'].filter((item) => item['all_periodes'] === 0), reservationYear, getMonthNumber(reservationMonth), reservationDay)}
                  isHidden={reservationDay === ''}
                  selectedTimes={selectedTimes}
                  setSelectedTimes={setSelectedTimes}
                  isError={selectedTimesError !== ''}
                  error={selectedTimesError}
                />
              </div>
            </div>
          </div>
          <CustomButton
            value={getLang(lang).reservationSalle.confirmer}
            handelClick={addReservation}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
